import { render, staticRenderFns } from "./myform.vue?vue&type=template&id=63440860&scoped=true"
import script from "./myform.vue?vue&type=script&lang=js"
export * from "./myform.vue?vue&type=script&lang=js"
import style0 from "./myform.vue?vue&type=style&index=0&id=63440860&prod&lang=less&scoped=true"
import style1 from "./myform.vue?vue&type=style&index=1&id=63440860&prod&lang=css"
import style2 from "./myform.vue?vue&type=style&index=2&id=63440860&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63440860",
  null
  
)

export default component.exports